import React from 'react';

import { useSearchContext } from '@atlas/core';

import useTranslate from 'common/I18n/Interpreter';
import { useSearch } from 'hooks/useSearch';

const SearchResult = () => {
  const t = useTranslate();

  const { resultLength } = useSearch();
  const { events, tournaments } = useSearchContext();

  if (!tournaments.length && !events.length) return null;

  return (
    <p className="search-results-count">
      {t('sportsbook_search_results_found')} {resultLength}
    </p>
  );
};

export default SearchResult;
